import { render, staticRenderFns } from "./cnAgreement.vue?vue&type=template&id=2179249a&scoped=true&"
import script from "./cnAgreement.vue?vue&type=script&lang=js&"
export * from "./cnAgreement.vue?vue&type=script&lang=js&"
import style0 from "./cnAgreement.vue?vue&type=style&index=0&id=2179249a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179249a",
  null
  
)

export default component.exports